import { useQueryClient } from 'react-query';
import type { Employer, User } from 'services/requests';

export const useSetData = <D extends User | Employer>() => {
  const queryClient = useQueryClient();

  return (data: D, queryKey: string) => {
    queryClient.setQueryData([queryKey, data.id.toString()], data);
  };
};
